import { Color, MathFunctions } from '@zeainc/zea-engine'

export const findDistinctColor = (skipList) => {
  const maxAttempts = 50
  let attempt = 0

  while (attempt <= maxAttempts) {
    const color = getRandomColor()
    const isAnySimilar = skipList.some((c) => c.approxEqual(color, 0.2))

    if (!isAnySimilar) return color

    attempt++
  }
}

export const getRandomColor = () => {
  let h = MathFunctions.randomInt(0, 360)
  const s = 0.9
  const l = 0.5
  const [r, g, b] = hsl2rgb(h, s, l)

  return new Color(r, g, b)
}

// input: h as an angle in [0,360] and s,l in [0,1] - output: r,g,b in [0,1]
function hsl2rgb(h, s, l) {
  let a = s * Math.min(l, 1 - l)
  let f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)
  return [f(0), f(8), f(4)]
}
